import { FC } from "react";
import Marquee from "react-fast-marquee";
import { clientLogos } from "../utils";
import { SectionProps } from "../../../interfaces";

export const Clients: FC<SectionProps> = ({ t }) => {
  return (
    <section className="bg-[#FDFCFF] py-16 px-[5%] sm:px-[3%]">
      <div className="max-w-[80rem] mx-auto">
        <h2 className="text-2xl/relaxed lg:text-3xl/relaxed font-medium text-center">
          {t("home.theyAlreadyLiveRealCashless")}
        </h2>
        <div className="w-full flex pt-10 overflow-hidden">
          <Marquee
            className="flex"
            speed={100}
            gradient={true}
            gradientColor="#FDFCFF"
            gradientWidth={128}
          >
            {clientLogos.map((logo) => (
              <img
                key={logo.alt}
                src={logo.src}
                alt={logo.alt}
                className="h-[75px] max-w-32 object-contain mx-8"
              />
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
